import { i18n } from "@v2/shared/config";

const fields = {
  types: [
    {
      id: "vamPEWeIB",
      title: "Производство",
      title_eng: "Manufactury",
      inner: [
        {
          id: "Ehbf6B80D4",
          title: "сырье и ингредиенты",
          title_eng: "raw materials and ingredients"
        },
        {
          id: "isQqBUTbOV",
          title: "материалы",
          title_eng: "auxiliary materials"
        },
        {
          id: "LBxNyxPmXZ",
          title: "оборудование",
          title_eng: "machinery, equipment"
        },
        {
          id: "Z_eaRkWmyB",
          title: "комплектующие",
          title_eng: "components and tools"
        },
        {
          id: "kbomT1fezU",
          title: "готовая продукция",
          title_eng: "finished products"
        }
      ]
    },
    {
      id: "c7ruC8afzo",
      title: "Торговля",
      title_eng: "Trade",
      inner: [
        {
          id: "c7ruC8afzo1",
          title: "оптовая",
          title_eng: "wholesale"
        },
        {
          id: "c0fXaZX0Xh2",
          title: "розничная",
          title_eng: "retail"
        },
        {
          id: "c0fXaZX0Xh",
          title: "сырье и ингредиенты",
          title_eng: "raw materials and ingredients"
        },
        {
          id: "BOos1q-If0",
          title: "материалы",
          title_eng: "auxiliary materials"
        },
        {
          id: "hJsVEyB7C6",
          title: "оборудование",
          title_eng: "machinery, equipment"
        },
        {
          id: "dy2E8GPAfw",
          title: "комплектующие",
          title_eng: "components and tools"
        },
        {
          id: "WkqgggLLJL",
          title: "готовая продукция",
          title_eng: "finished products"
        }
      ]
    },
    {
      id: "F58BJV24Md",
      title: "Оказание услуг",
      title_eng: "Services"
    },
    {
      id: "RMep01XLBl",
      title: "Научно-исследовательска деятельность",
      title_eng: "Research and development"
    },
    {
      id: "JKCQeIQaUx",
      title: "Государственная структура",
      title_eng: "Government institution"
    },
    {
      id: "9pvfwR2BpM",
      title: "Некоммерческие организации",
      title_eng: "Non-business enterprise"
    }
  ],

  sizes: [
    {
      id: "eOOmkWL2Z",
      title: "Контрактное производство. Субконтрактинг",
      title_eng: "Subcontracting"
    },
    {
      id: "V3HC8Wf9Cd",
      title: "Услуги для государства (госзакупки)",
      title_eng: "Services for government (government procurement)"
    },
    {
      id: "TJzt43ySFq",
      title: "Малый и средний бизнес",
      title_eng: "Small and medium enterprises"
    },
    {
      id: "xI0y-DR8UR",
      title: "Инновации. Стартапы",
      title_eng: "Innovations. Start-ups"
    },
    {
      id: "E-8-jBAKId",
      title: "Экспорт",
      title_eng: "Export"
    },
    {
      id: "ZBwrLPJMrs",
      title: "Импорт",
      title_eng: "Import"
    }
  ],

  scopes: [
    {
      id: "TZ5bPX-pR",
      title: "Автомобили, вело-, мототехника",
      title_eng: "Cars, Bicycle, motor vehicles"
    },
    {
      id: "-8JWKrdhsw",
      title: "Аддитивные и нанотехнологии",
      title_eng: "Additive and nanotechnologies"
    },
    {
      id: "B_BuQeW_eJ",
      title: "Архитектура и дизайн",
      title_eng: "Architecture and design"
    },
    {
      id: "w7JZc3pG1l",
      title: "Аэрокосмическая промышленность",
      title_eng: "Aircraft engineering and aerospace industry"
    },
    {
      id: "ev3zkM-TdS",
      title: "Безопасность, пожарная безопасность, охрана труда",
      title_eng: "Safety, fire safety, labor protection"
    },
    {
      id: "xpC9qDV68h",
      title: "Водоотведение, водоочистка",
      title_eng: "Wastewater, water treatment"
    },
    {
      id: "XITp5xar2I",
      title: "Вооружение, военная техника",
      title_eng: "Armament, military equipment"
    },
    {
      id: "25nRxb-t44",
      title: "Выставки, конгрессы, ярмарки",
      title_eng: "Exhibitions, congresses, trade fairs"
    },
    {
      id: "g4psJaQtYp",
      title: "Горнодобывающая промышленность",
      title_eng: "Mining industry"
    },
    {
      id: "amGZ8wI7Il",
      title: "Гостиничный и ресторанный бизнес",
      title_eng: "Hotel and restaurant business"
    },
    {
      id: "1ZH564WgE0",
      title: "Грузоподъемная техника",
      title_eng: "Lifting equipment"
    },
    {
      id: "gTeUuAfKy3",
      title: "Детский мир. Товары для детей",
      title_eng: "Children's world. Goods for children"
    },
    {
      id: "68XI2buc5A",
      title: "Дорожная техника, строительство дорог",
      title_eng: "Road equipment, road construction"
    },
    {
      id: "uHVB0ww1jE",
      title: "Зоомир, товары для животных. Ветеринария",
      title_eng: "Veterinary products for animals. Veterinary science"
    },
    {
      id: "iss92shXyB",
      title: "Индустрия красоты, косметика, парфюмерия",
      title_eng: "Beauty industry, cosmetics, perfumery"
    },
    {
      id: "5lRDoGGT5V",
      title: "Интеллектуальная собственность, патентное право",
      title_eng: "Intellectual property, patent law"
    },
    {
      id: "sYs1dxmB3bN",
      title: "Информационные технологии",
      title_eng: "Information technologies"
    },
    {
      id: "wnBLXGogrBN",
      title: "Телекоммуникации и связь",
      title_eng: "Telecommunications and data transmission"
    },
    {
      id: "LjGhO27ki5R",
      title: "Книги, издательское дело",
      title_eng: "Books, publishing"
    },
    {
      id: "9XrDbwSUBdp",
      title:
        "Компьютерные инженерные технологии, автоматизация производства, метрология",
      title_eng:
        "Computer engineering technologies, production automation, metrology"
    },
    {
      id: "YKtGOSvCBIz",
      title: "Культура, искусство",
      title_eng: "Culture, Art"
    },
    {
      id: "97HfLkMzVFK",
      title: "Лабораторные технологии, биотехнологии",
      title_eng: "Laboratory technology, biotechnology"
    },
    {
      id: "mtcs9jdUYvU",
      title: "Ландшафтный дизайн. Флористика. Садоводство",
      title_eng: "Landscape design. Floristic. Gardening"
    },
    {
      id: "RhcgRwdPCrd",
      title: "Лес и деревообработка",
      title_eng: "Wood and woodworking"
    },
    {
      id: "lbpJUlgJ4gS",
      title: "Логистика, доставка грузов, склад",
      title_eng: "Logistics, cargo delivery, warehouse"
    },
    {
      id: "-Uuln4oV9RK",
      title: "Машиностроение, металлообработка, станки",
      title_eng: "Mechanical engineering, Metalworking, machine tools"
    },
    {
      id: "1v_o_oxevqf",
      title: "Мебель для дома и офиса, предметы быта",
      title_eng: "Furniture for home and office, household items"
    },
    {
      id: "_gQlyiVp9yg",
      title: "Медицина, здоровье, гигиена",
      title_eng: "Medicine, health, hygiene"
    },
    {
      id: "0f4rp2FvCZe",
      title: "Металлоизделия и приборы",
      title_eng: "Metalware hardware and tools"
    },
    {
      id: "g13hOwPrw9U",
      title: "Металлургия",
      title_eng: "Metallurgy"
    },
    {
      id: "FjTMeLlJWkg",
      title: "Навигационные технологии и системы",
      title_eng: "Navigation technologies and systems"
    },
    {
      id: "x1DynBxzlQo",
      title: "Наука",
      title_eng: "Science"
    },
    {
      id: "6dHJ_NyIEid",
      title: "Недвижимость – аренда и продажа",
      title_eng: "Real estate - rent and sale"
    },
    {
      id: "UenJQECBi8m",
      title: "Нефть и газ",
      title_eng: "Oil and gas"
    },
    {
      id: "YscPRAZfx1h",
      title: "Образование",
      title_eng: "Education"
    },
    {
      id: "bGDCkFaTsZC",
      title: "Одежда, обувь, кожа, меха",
      title_eng: "Clothing, shoes, leather, fur"
    },
    {
      id: "BEaB5bO91nE",
      title: "Оптическая промышленность. Лазеры",
      title_eng: "Optical industry. Lasers"
    },
    {
      id: "ztuO16mn-u6",
      title: "Освещение, световые решения",
      title_eng: "Lighting, lighting solutions"
    },
    {
      id: "RxMpgNAHJAm",
      title: "Отопление, кондиционирование,охлаждение, вентиляция",
      title_eng: "Heating, air conditioning, cooling, ventilation"
    },
    {
      id: "je-h-MHGAM3",
      title: "Отраслевые ассоциации, профессиональные объединения и союзы",
      title_eng: "Industry associations, trade associations and unions"
    },
    {
      id: "Dj3sUzl5918",
      title: "Охрана окружающей среды",
      title_eng: "Environmental protection"
    },
    {
      id: "6ZXEskB2CEV",
      title: "Переработка пластмасс и каучука",
      title_eng: "Plastics and rubber processing"
    },
    {
      id: "MP_m9nFkC6T",
      title: "Пищевая промышленность: оборудование и ингредиенты",
      title_eng: "Food industry: equipment and ingredients"
    },
    {
      id: "DPoas5jI3a0",
      title: "Продукты питания и напитки",
      title_eng: "Food and beverages"
    },
    {
      id: "ujK2aA5tqWy",
      title: "Проектирование объектов",
      title_eng: "Object design"
    },
    {
      id: "BPmN-7qI5Xn",
      title: "Промышленное оборудование, эксплуатация и ремонт",
      title_eng: "Industrial equipment, operation and repair"
    },
    {
      id: "H7nJcPUpb5z",
      title: "Реклама, дизайн, полиграфия",
      title_eng: "Advertising, design, printing"
    },
    {
      id: "6VnUbmtdxsQ",
      title: "Религия",
      title_eng: "Religion"
    },
    {
      id: "itAaElMnlSQ",
      title: "Сельское хозяйство",
      title_eng: "Agriculture"
    },
    {
      id: "Hpj9Sba3-Ke",
      title: "Спорт, охота и рыбалка",
      title_eng: "Sport, hunting and fishing"
    },
    {
      id: "BD43yxhnz84",
      title: "Средства массовой информации",
      title_eng: "Mass Media"
    },
    {
      id: "I2kYL0JKmXk",
      title: "Стекло. Оборудование для производства/обработки стекла",
      title_eng: "Glass. Glass production/processing equipment"
    },
    {
      id: "i42buAnajne",
      title: "Строительство, отделочные материалы ",
      title_eng: "Construction, finishing materials"
    },
    {
      id: "qa4D7BN1us5",
      title: "Судостроение, катера, яхты",
      title_eng: "Shipbuilding, boats, yachts"
    },
    {
      id: "3TriTdZjy_e",
      title: "Текстиль, ткани",
      title_eng: "Textiles, fabrics"
    },
    {
      id: "dKGuIDsNfAh",
      title: "Технологии обработки поверхности",
      title_eng: "Surface treatment technologies"
    },
    {
      id: "PFrQWU2alLw",
      title: "Товары для дома, посуда, сувениры",
      title_eng: "Household goods, dishes, souvenirs"
    },
    {
      id: "7e-cK5JJrZa",
      title: "Туризм и отдых",
      title_eng: "Tourism and recreation"
    },
    {
      id: "GZQskA32e8T",
      title: "Упаковка, упаковочное оборудование",
      title_eng: "Packaging, packaging equipment"
    },
    {
      id: "f4u-v7hPQQE",
      title: "Фармацевтика",
      title_eng: "Pharmaceutics"
    },
    {
      id: "4WOIigHKOCw",
      title: "Финансовые и страховые услуги. Услуги для бизнеса",
      title_eng: "Financial and insurance services. Business services"
    },
    {
      id: "6rqrhVGcjml",
      title:
        "Химическая и нефтехимическая промышленность. Полимерные материалы",
      title_eng: "Chemical and petrochemical industry. Polymeric materials"
    },
    {
      id: "sRiR1oSj1q-",
      title: "Экология и рециклинг. Возобновляемые источники энергии",
      title_eng: "Ecology and recycling. Renewable energy sources"
    },
    {
      id: "6Dzy2cUZ8QB",
      title: "Эксплуатация зданий и объектов",
      title_eng: "Operation of buildings and facilities"
    },
    {
      id: "Puh2sO0FyZH",
      title: "Электроника и комплектующие",
      title_eng: "Electronics and accessories"
    },
    {
      id: "YmdHLejhJap",
      title: "Электротехника",
      title_eng: "Electrical engineering"
    },
    {
      id: "-IS2souG0zK",
      title: "Энергетика",
      title_eng: "Power industry"
    },
    {
      id: "P28uU6xR5Vk",
      title: "Ювелирная и часовая отрасль",
      title_eng: "Jewelry and watch industry"
    }
  ],

  productRoles: [
    {
      id: "aswpfJnZ8",
      title: "Авиационная и космическая промышленность",
      title_eng: "Aircraft engineering and aerospace industry"
    },
    {
      id: "Mk90nli1tQ",
      title: "Автомобилестроение и ремонт",
      title_eng: "Automotive industry and repair"
    },
    {
      id: "kvI9H2rE9N",
      title: "Агропромышленный комплекс и сельское хозяйство",
      title_eng: "Agroindustrial sector"
    },
    {
      id: "4Wjo1DYQJR",
      title: "Водоснабжение, водоподготовка и водоочистка",
      title_eng: "Water treatment, water conditioning and purification"
    },
    {
      id: "HJbyjaNkQd",
      title: "Военно-промышленный комплекс",
      title_eng: "Military-industrial sector, defense industry"
    },
    {
      id: "ctRVeZaNXi",
      title: "Деревообработка и производство мебели",
      title_eng: "Woodworking industry and furniture production"
    },
    {
      id: "Z5K6lHd0kR",
      title: "Дорожное строительство",
      title_eng: "Road construction"
    },
    {
      id: "l8T43qeMAe",
      title: "Индустрия товаров широкого потребления",
      title_eng: "Industry of consumption goods"
    },
    {
      id: "l_ZWgDJmec",
      title: "Информационные технологии, автоматизация производства",
      title_eng: "Information technology, automation"
    },
    {
      id: "L2_2vATZRh",
      title: "Легкая и текстильная промышленность",
      title_eng: "Textile industry"
    },
    {
      id: "PInvcRvE2i",
      title: "Маркетинг и реклама",
      title_eng: "Marketing and advertising"
    },
    {
      id: "U2s4kOyr1K",
      title: "Машиностроение",
      title_eng: "Machine building"
    },
    {
      id: "-W-ukcmCra",
      title: "Медицина / фармацевтическая промышленность",
      title_eng: "Medicine and pharmacy"
    },
    {
      id: "SNmyqTgxcR",
      title: "Металлургия и горная промышленность",
      title_eng: "Metallurgy and mining industry"
    },
    {
      id: "BL4KWFUQGe",
      title: "Мостостроение",
      title_eng: "Bridge construction"
    },
    {
      id: "K06VUhbIte",
      title: "Научные исследования и разработки, нанотехнологии",
      title_eng: "R&D, nanotechnologies"
    },
    {
      id: "G9PLBs-zGPi",
      title: "Нефтегазовый комплекс (добыча и переработка)",
      title_eng: "Oil and gas industry"
    },
    {
      id: "qSHV46bhq5Z",
      title: "Нефтегазохимическое производство",
      title_eng: "Petrochemical industry"
    },
    {
      id: "P6Ed--4Chim",
      title:
        "Охрана окружающей среды, переработка и утилизация отходов, экология"
    },
    {
      id: "WINqxKo4Z-r",
      title: "Пищевая промышленность",
      title_eng: "Recycling, environment protection, ecology"
    },
    {
      id: "fFIuNV2SX5V",
      title: "Строительство, производство строительных материалов",
      title_eng: "Food industry"
    },
    {
      id: "lNYLk8Wk_zP",
      title: "Судостроение",
      title_eng:
        "Construction, manufacture of construction materials and chemicals"
    },
    {
      id: "S4z2GuDtS-f",
      title: "Химическая промышленность",
      title_eng: "Shipbuilding"
    },
    {
      id: "RyRtLuf7o4u",
      title: "Целлюлозно-бумажная промышленность",
      title_eng: "Chemical industry"
    },
    {
      id: "7zHmiM2xu6M",
      title: "Электроника и электротехника",
      title_eng: "Pulp and paper industry"
    },
    {
      id: "RAKw0q6Lfro",
      title: "Энергетика",
      title_eng: "Electronics and electrotechnical industry"
    }
  ]
};

function processField(data, prefix = "") {
  let processedData = [];

  data.forEach((item, index) => {
    let title = `${index + 1}. ${
      i18n.locale === "en" ? item.title_eng : item.title
    }`;

    if (prefix) {
      title = prefix + "." + title;
    }

    processedData.push({
      value: item.id,
      title: title
    });

    if (item.inner) {
      processedData = processedData.concat(processField(item.inner, index + 1));
    }
  });

  return processedData;
}

fields.types = processField(fields.types);
fields.sizes = processField(fields.sizes);
fields.scopes = processField(fields.scopes);
fields.productRoles = processField(fields.productRoles);

export default fields;
